import React, { useEffect, useState } from 'react';
import { Popover } from 'react-tiny-popover';
import ControlUtils from '../utils/control-utils';

const ControlElement = (props) => {
   const { listControl, element, children, onChange, value } = props
   const [isShow, setIsShow] = useState(false);

   const handleReplace = (code, name) => {
      const { id } = element;
      const data = value.map((item) => {
         return {
            ...item, children: item.children.map((child) => {
               if (child.id === id) {

                  return {
                     ...child,
                     code,
                     children: [{ text: name }]
                  }
               }
               return child;
            })
         }
      });
      onChange(data);
   }

   const handleClick = () => {
      setIsShow(true)
   }

   return (
      <Popover
         isOpen={isShow}
         positions={['bottom']}
         onClickOutside={() => setIsShow(false)}
         clickOutsideCapture={true}
         content={<ControlUtils listControl={listControl} handleClick={handleReplace} />
         }
      >
         <div className='link' onClick={handleClick} contentEditable={false}>
            <span className="input-text-plugins-vars-item pointer"  >
               <span className="badges badges-primary" >{children}</span>
            </span>
         </div>
      </Popover>
   )
};

export default ControlElement;